import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {t, Trans} from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import {SelectBox, typeValuesListItem} from "../../../../../UI/SelectBox/SelectBox";
import {getStoreList} from "../../../../../../model/dashboardStores/dStoresAPI";
import {logoutSagaAC} from "../../../../../../model/system/systemActionCreators";
import {Loader} from "../../../../../UI/Loader/Loader";
import {
    dProductsDeleteAllFromStoreSagaAC,
    dProductsDeleteAllSagaAC, dProductsSetItemsForPageAC,
    dProductsSetPageNumberAC
} from "../../../../../../model/dashboardProducts/dProductsActionCreators";
import {typePaginationDashboardObject} from "../../../DashboardContentTable/PaginationDashboard/PaginationDashboard";
import {IdProductsState} from "../../../../../../model/dashboardProducts/dProductsReducer";
import {Alert} from "../../../../../UI/Alert/Alert";


// Type
export type typePopupDeleteAllFromStores = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const PopupDeleteAllFromStores: React.FC<typePopupDeleteAllFromStores> = ({ variant, setOpenPopup }) => {

    const dispatch = useDispatch()
    const filters = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.filters)

    useEffect(() => {
        const setData = async () => {
            setLoader(true)
            let responseStores = await getStoreList({ filters: { name: null }, full: false })

            if (responseStores.status === 200) {
                const mappingData: typeValuesListItem[] = responseStores.data.map((item: typeValuesListItem) => ( {
                    id: item.id,
                    name: item.name,
                } ))
                if (mappingData.length) setSelected('allStores')
                setStores([ {id: 'allStores', name: t`All stores`}, ...mappingData])

            } else if (responseStores.status === 401) {
                dispatch(logoutSagaAC())
            }
            setLoader(false)
        }
        setData().then(() => setLoader(false))

        // eslint-disable-next-line
    }, [])

    const [ stores, setStores ] = useState<typeValuesListItem[]>([])
    const [ selected, setSelected ] = useState<string|number|null>(null)
    const [ loader, setLoader ] = useState(false)

    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dProducts: IdProductsState }) => state.dProducts.pagination),
        onGoToPage: (id) => dispatch(dProductsSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dProductsSetItemsForPageAC(itemsPerPage))

    }

    const onDeleteAllConfirmHandler = () => {
        dispatch(dProductsDeleteAllSagaAC(filters, {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!
        }))
    }


    const onDeleteHandler = (e: React.FormEvent) => {
        e.preventDefault()

        if (selected === 'allStores') {
            onDeleteAllConfirmHandler()
        } else {

            if (selected) {
                dispatch(dProductsDeleteAllFromStoreSagaAC( selected, filters, {
                    page: pagination.paginationObject.pageNumber,
                    size: pagination.paginationObject.itemsPerPage!
                }))
            }
        }

        setOpenPopup(false)
    }

    return (
        <form onSubmit={ (e) => onDeleteHandler(e) } className="flex flex-col gap-4 relative">

            <Alert type={'error'} title={<Trans>Do you really want delete all products?<br/>All products will be moved to deleted</Trans>}/>

           <SelectBox withoutEmpty={true} required valuesList={stores} valueId={selected} setIdValue={setSelected} label={<Trans>Delete from:</Trans>} />

            <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <Button type="submit" variant={variant} label={<Trans>Delete</Trans>}/>
                <Button type="button" secondary={true} label={<Trans>Cancel</Trans>}
                        onClick={() => setOpenPopup(false)}/>
            </div>

            {loader && <Loader/>}

        </form>
    )
}
